import script from "./CommonAPI.vue?vue&type=script&lang=ts"
export * from "./CommonAPI.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__